import gql from 'graphql-tag';

export const queryForNoteTypes = gql`
  query queryForNoteTypes(
    $limit: Int
    $page: Int
    $query: NoteTypeSortOrQuery
    $sort: NoteTypeSortOrQuery
  ) {
    queryForNoteTypes(limit: $limit, page: $page, query: $query, sort: $sort) {
      items {
        id
        name
        Categories {
          id
          name
        }
        aors {
          id
          name
          abbreviation
        }
        active
        createdBy
        createdDate
        updatedBy
        updatedDate
        version
      }
      totalRecords
    }
  }
`;
